import { render, staticRenderFns } from "./Selection.vue?vue&type=template&id=54f3674d&scoped=true&"
import script from "./Selection.vue?vue&type=script&lang=js&"
export * from "./Selection.vue?vue&type=script&lang=js&"
import style0 from "./Selection.vue?vue&type=style&index=0&id=54f3674d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3674d",
  null
  
)

export default component.exports